<template>
  <div class="content">
    <div class="head_title">
      <div class="title1">桔家云整装设计团队</div>
      <div class="title2">精妙的原创设计，您的专属定制</div>
      <div class="Scribing"></div>
    </div>
    <div class="Design-swiper">
      <div class="Design-one">
        <div
          class="Designer-show"
          v-for="(item,index) in msg2"
          :key="index"
          @mouseenter="enter(item)"
          @mouseleave="leave(item)"
        >
          <img :src="item.userpic" alt oncontextmenu="return false;" />
          <transition name="slide-fade">
            <div class="picture-Mask" v-if="item.show">
              <p>{{item.allname}}&nbsp;|&nbsp;厦门</p>
              <div>从业年限：{{item.workyear}}年</div>
              <div class="designertext">{{item.usermemo}}</div>
            </div>
          </transition>
          <transition name="slide-fade">
            <div class="picture-Mask2" v-if="item.show">
              <div @click="todetail(item)">查看案例</div>
              <div @click="free">预约设计</div>
            </div>
          </transition>
        </div>
      </div>
    </div>
    <router-link to="Designer">
      <div class="Seemore">查看更多</div>
    </router-link>
  </div>
</template>
<script>
import Vue from "vue";
export default {
  data() {
    return {
      msg2: []
    };
  },
  methods: {
        todetail(item) {
      this.$router.push({ path: "/DesignerDetails", query: { resl: item.id } });
    },
    enter(item) {
      item.show = true;
    },

    leave(item) {
      item.show = false;
    },
    getpostshejis: async function() {
      let data = {
        area: "",
        city: "厦门市",
        limit: 6,
        page: 1,
        province: "福建省"
      };
      let res = await this.exequy.postshejis(data);
      res.data.data.list.map(vl => {
        vl.show = false;
      });
      this.msg2 = res.data.data.list.splice(0,5);
    },
    todecomethod() {
      this.$router.push({ path: "/DecoMethod" });
    },
    free() {
      this.$router.push({ path: "/NewFreeRegistration" });
    },
  },
  created() {
    const self = this;
    self.getpostshejis();
  }
};
</script>
<style scoped>
.title1 {
  width: 100%;
  text-align: center;
  font-size: 30px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 3px;
  color: #333333;
  margin-top: 50px;
}
.title2 {
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 2px;
  color: #666666;
}
.Scribing {
  width: 50px;
  height: 6px;
  background-color: #bc001d;
  margin: 0 auto;
  margin-top: 20px;
}
.Design-swiper {
  width: 1280px;
  margin: 0 auto;
}
.Design-one {
  display: flex;
  justify-content: space-around;
  margin-top: 50px;
}
.Designer-show img {
  height: 100%;
  width: 100%;
}
.Designer-show {
  width: 240px;
  height: 260px;
  position: relative;
  transition: all 0.6s;
}
.Designer-show:hover {
  transform: scale(1.1);
}
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.6s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateY(5px);
  opacity: 0;
}
.picture-Mask {
  width: 100%;
  background: rgba(63, 63, 63, 0.514);
  position: absolute;
  bottom: 5px;
}
.picture-Mask2 {
  width: 100%;
  height: 150px;
  position: absolute;
  font-size: 15px;
  bottom: -140px;
}
.picture-Mask2 > div {
  width: 50%;
  height: 25px;
  line-height: 25px;
  font-size: 15px;
}
.picture-Mask2 div:first-child {
  float: left;
  cursor: pointer;
  background: #b31d25;
  color: #fff;
}
.picture-Mask2 div:last-child {
  float: right;
  cursor: pointer;
  background: #fff;
  color: #000;
}
.picture-Mask > p {
  width: 80%;
  font-size: 19px;
  line-height: 2.3rem;
  color: #fff;
  text-align: center;
  margin: 0 auto;
  border-bottom: 1px solid #fff;
}
.picture-Mask > div {
  font-size: 15px;
  width: 100%;
  margin-top: 5px;
  color: #fff;
}
.picture-Mask[data-v-73ac31ee]{
  bottom: 10px;
}
.Seemore {
  width: 100px;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  color: #bc001d;
  border: solid 1px #bc001d;
  margin: 0 auto;
  margin-top: 60px;
  margin-bottom: 60px;
}
</style>
